<template>
  <div id="video_page">
    <div class="left_part">
      <div class="left_main">
        <div class="left_tabs" v-if="create_type">
          <div flex-center :class="['tab_item', { 'active': create_form.create_type == 1 }]"
               @click="changeTab(1)">文生视频
          </div>
          <div flex-center :class="['tab_item', { 'active': create_form.create_type == 2 }]"
               @click="changeTab(2)">图生视频
          </div>
        </div>
        <div class="tools_introduce">
          <img class="face_icon" src="./img/face.png" alt="">
          <div class="introduce_main">
            <div class="introduce_title">功能介绍</div>
            <div class="introduce_text">全新 AI 视频 Luma 重磅上线，生成效果大幅度的提升，视频质量更高清
            </div>
          </div>
        </div>
        <lingganTool
        ref="lingganref" 
        :MD5_KEY="'e43537239e006c060f3809c7d5090fcc'"
        :show_list="['desc','img_urls']"
        @createSame="createSame"
        @use_only="use_only"
        ></lingganTool>

        <div class="form_wrap">
          <div class="describe" v-if="create_form.create_type == 2">
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">上传图片</div>
            </div>
            <div>
            </div>
            <div class="Reference_image" v-loading="upImgloading"
                 element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload
                  class="upload-demo"
                  drag
                  accept=".jpg,.png"
                  :action="fileApi+'/api/front/aivideo/upload/?soft=1'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  multiple>
                <div v-if="create_form.img_url" class="yesUpload">
                  <img :src="cdn_url_replace(create_form.img_url)" alt="" class="yesUpload_img">
                  <div class="yesUpload_icon" @click.stop="create_form.img_url=''">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-else class="noUpload">
                  <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                  <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                  <div> 只能上传jpg/png文件，且不超过10MB</div>
                </div>
              </el-upload>
            </div>
          </div>
          <div class="description">
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">描述你的视频场景
                <!-- <div :class="create_form.desc.trim().length?'tishici tishici_act':'tishici'" @click="showTishici">优化提示词</div> -->
              </div>
            </div>
            <div class="desc_box" id="only_desc"  slot="reference">
              <el-input :input-style="{ minHeight: '31px' }" :rows="4" v-model="create_form.desc" type="textarea"
                        placeholder="请输入创意描述，包含内容主体+动作/场景，一键生成"/>
              <div class="desc_box_bottom">
                <div class="bottom_left" @click="showTishici">
                  <!-- <el-switch v-model="auto_spell"
                             @change="getPromptData4()"
                             active-value="1"
                             inactive-value="0"
                             active-color="#5865F2"
                             inactive-color="#ffffff2d">
                  </el-switch> -->
                  <div><img src="@/components/images/lingganImg/ai_tishi.png" class="ai_tishi_img" alt=""> 
                      Ai优化提示词（免费）</div>
                </div>
                <div class="cleat_desc_btn" @click="create_form.desc = ''">清空</div>
              </div>
            </div>
          </div>
          <div>
            <!-- <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">视频清晰度</div>
            </div> -->
            <!-- <div class="model_wrap">
              <div @click="selectDefinition(du)"
                   :class="['model_item', 'select_item', { 'active': create_form.is_hd == du.value }]" flex-center
                   v-for="du in definition">{{ du.name }}
                <div class="need_vip" v-if="du.need_vip">VIP</div>
              </div>
            </div> -->
          </div>
          <div>
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">视频时长</div>
            </div>
            <div class="model_wrap">
              <div @click="selectDuration(du)"
                   :class="['model_item', 'select_item', { 'active': create_form.duration == du.value }]" flex-center
                   v-for="du in duration_list">{{ du.name }}
                <div class="need_vip" v-if="du.need_vip">VIP</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- <div class="left_footer">
        <div :class="['primary_button', { 'disabled_btn': create_form.model == 3 }]"
             @click="clickSubmit"
             v-loading="sendLoading">
          {{ create_form.model == 3 ? '敬请期待' : '提交任务' }}
          <span class="fz12" v-if="create_form.model != 3">（消耗{{ scoreCode }}积分）</span></div>
      </div> -->
      <div class="newSubList">
        <div class="newSumit newSumitOthers" v-show="create_form.mode == 'Sora'">
          敬请期待
        </div>
        <div class="newSumitList">
          <div class="newSumit" @click="clickSubmit" v-show="create_form.mode != 'Sora'">
            生成标清
            <div class="subText">（消耗{{ scoreCode }}积分）</div>
          </div>
          <div class="newSumit newSumitOther" @click="create_form.is_hd=1,clickSubmit()"
               v-show="create_form.mode != 'Sora'">
            生成高清
            <div class="subText">（消耗{{ newscoreCode }}积分）</div>
            <img src="./img/img_icon_hot01.gif" class="subImg" alt="">
          </div>
        </div>
        <div class="screen">
          内容由 Ai 生成，请仔细甄别
        </div>
      </div>
    </div>
    <div class="main_part">
      <div class="top_tips">
        <span class="one">#</span><span class="two">创作中心</span><span class="three">请遵守中华人民共和国网络安全法，严禁生成涉及政治人物，色情、恐怖等不良内容， 如有违规封号处理</span>
      </div>
      <div class="create_center" ref="scrollWrap" @scroll="testScroll">
        <!--样例开始-->
        <div class="message_list"
             v-infinite-scroll="fettchSampleList"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="SampleListDisabled"
             v-if="!isLogin||video_list.length==0">
          <div class="list_item" v-for="(msg, index) in sampleSysList">
            <div class="item">
              <div class="item_touxiang">
                <img src="./img/modle_icon/Luma.png" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      Luma
                    </div>
                    <template>
                      <div class="item_type">
                        示例
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">
                    <div @click="sample_btn('del')">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('noDown')">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('put')">
                      <i class="el-icon-position"></i> 推荐广场
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap"
                     @click.stop="handlePlay('play',index,msg)">
                  <div class="creating" v-if="msg.status===1">
                    <template v-if="msg.progress > 10">
                      <div class="progress">{{ msg.progress }}%</div>
                      <img class="loading_gif" src="./img/loading-new.gif">
                    </template>
                    <template v-else>
                      <img class="loading_gif" src="./img/loading-new.gif">
                      <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                    </template>
                  </div>
                  <video controls controlslist="nodownload"
                         :poster="msg.cover_url"
                         preload="none" v-loading="true"
                         v-else style="width: 665px;height: 400px" :src="msg.video_url"
                         @play="handlePlay('',index)"
                         :ref="`videoPlayer${index}`"></video>
                  <div class="tozan">
                    <div class="zanOne" @click="tozanFn(msg,index)" v-show="!msg.is_vote">
                      <img src="./img/zan1.png" class="zanImg"/> 赞一下
                    </div>
                    <div class="zanDetail" v-show="msg.is_vote">
                      <div class="zanOne zanTwo">
                        <img src="./img/zan2.png" class="zanImg"/> 已赞过
                      </div>
                    </div>
                    <div class="zanTex">
                      此作品已获得{{ msg.votes }}个赞
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--样例结束-->

        <div class="message_list" v-infinite-scroll="loadMore"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="noMore">
          <div class="list_item" v-for="(msg, index) in video_list">
            <div class="item">
              <div class="item_touxiang">
                <img src="./img/modle_icon/Luma.png" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      Luma
                    </div>
                    <template>
                      <div class="item_type">
                        {{ msg.img_url != '' ? '图生视频' : '文生视频' }}
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">
                    <div @click="deleteVideo(index, msg)">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="downloadVideo( msg,index)">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div v-if="msg.status == 2">
                      <div style="margin-left: 5px" v-if="msg.is_public==0||msg.is_public==null"
                           @click="recommend(msg.id,index)">
                        <i class="el-icon-position"></i> 推荐广场
                      </div>
                      <div style="margin-left: 5px" v-else>
                        <i class="el-icon-position"></i> 已推荐到广场
                      </div>
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap">
                  <div v-if="msg.status == 0">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress">{{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 1">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress"> 正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 2 && msg.local_video_url === null">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress"> 正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 2&& msg.local_video_url !== null" class="success_shou">
                    <div class="success_shouVideo"
                         @click.stop="onVideoPlay('play',index,msg)">
                      <video controlslist="nodownload"
                          :poster="msg.cover_url!=null?msg.cover_url:''"
                          :preload="msg.cover_url!=null?'none':'auto'" v-loading="true"
                          controls :src="msg.local_video_url"
                             :ref="`videoPlayers${index}`"
                             @play="onVideoPlay('',index)"></video>
                      <div v-if="msg.img_url !=null || msg.img_url !=''" class="success_img"
                           :style="msg.img_url ==null || msg.img_url ==''?'display:none;':'display:;'">
                        <img :src="msg.img_url" alt="" class="xianshi">
                        <div class="success_imgdel">
                          <div style="display: flex;align-items: flex-end;">
                            <span
                                style="background: #5865f2a8;border-radius: 3px;margin:  2px;padding: 0 4px;color: white">生成前</span>
                          </div>
                          <div style="display: flex;flex-direction: column;padding: 2px 2px 0 0 ;">
                            <i class="el-icon-close yichang" @click="msg.img_url = ''"></i>
                          </div>
                        </div>
                      </div>
                      <div :style="msg.img_url ==null || msg.img_url ==''?'display:none;':'display:;'"
                           style="position: absolute;top: 2px;left: 0;">
                        <span
                            style="z-index: 10;  background: #5865f2a8;border-radius: 3px;margin: 2px;padding: 3px 4px;color: white">生成后</span>
                      </div>
                    </div>
                  </div>
                  <div class="error_video" v-loading="msg.regenLoading > 0 "
                       v-if="(msg.status == 3)&&(msg.retry_num<3 && msg.is_retry==0)">
                    <!-- 绘画 失败 -->
                    <img class="error_icon" src="./img/image_error.png" alt="">
                    <div class="error_text">很遗憾，生成失败 !</div>
                    <div class="error_text2" @click="regenerate(msg,index)">点此重新生成</div>
                    <div class="error_text3">（成功率在90%以上）</div>
                    <div class="error_text4" v-if="msg.show_error">
                      失败原因： <span style="color:red;">{{ msg.show_error }}</span>
                    </div>
                    <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                        :href="kefu_url"
                        target="_blank">在线客服</a></div>
                  </div>
                  <div class="error_video create_error_old"
                       v-else-if="(msg.status == 3)&&(msg.retry_num>=3 || msg.is_retry!=0)">
                    <!-- 绘画 失败 -->
                    <img class="error_icon" src="./img/image_error.png" alt="">
                    <div class="error_text">很遗憾，生成失败 !</div>
                    <div class="error_btn" @click="showDefeatPopup()">查看失败原因</div>
                    <div class="error_text3">（成功率在90%以上）</div>
                    <div class="error_text4" v-if="msg.show_error">
                      失败原因： <span style="color:red;">{{ msg.show_error }}</span>
                    </div>
                    <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                        :href="kefu_url"
                        target="_blank">在线客服</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    <shibaiyuanyin ref="retryPop"></shibaiyuanyin>

    <!-- ai提示词 -->
    <AIpromptWords
        :typedata="'Luma'"
        :inpdata="create_form.desc"
        @getPromptData1="getPromptData2"
        ref="promptBox"/>
  </div>

</template>
<script type="text/ecmascript-6">

import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import shibaiyuanyin from "COMPONENTS/shibaiyuanyin.vue";
import lingganTool from "COMPONENTS/lingganTool.vue";
import utils from '../../utils'
import AliCdn from '../../utils/ali_cdn'
import AIpromptWords from "COMPONENTS/AIpromptWords.vue";

export default {
  components: {AIpromptWords, shibaiyuanyin, faceVerifyPopup,lingganTool},
  data() {
    return {
      kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      scoreCode: 25,
      
      create_form: {
        create_type: 1,
        img_url: "",//普通
        desc: "",
        auto_optimize: false,
        style: 0,
        size: '16:9',
        duration: 5,
        soft: 4,
        aspect_ratio: 3,
        mode: 'gen3a',
        seconds: 5,// 默认视频时长
        exploreMode: false, //true探索模式 false积分模式
        img_urls: "",//以图片作为结尾帧
        is_hd: 0,// 清晰度
      },
      cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      frame: false,
      imgDialogVisible: false,
      video_list: [],
      noMore: true,
      page: 1,
      select_rec_img: {
        img_url: ''
      },
      timer: null,
      max_mj_id: 0,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      // sampleSelectList: [], // 选择样例
      sampleTimer: null,
      fileApi: FILE_API_SERVER,
      definition: [
        {name: '标清', value: 0},
        {name: '高清', value: 1},
      ],
      upImgloading: false,
      zanID: 0,
      isZan: false,
      votes: 0,
      auto_spell: '1',
      perIncan: false, // ai提示词是否返回
      newscoreCode: 50,
      isTips: false,
      SampleListDisabled: true,
    }

  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    create_type() {
      this.create_form.create_type = this.$store.state.video_type || 1;
      return this.$store.state.video_type || 1;
    },
    duration_list() {
      return [{name: '5秒', need_vip: 0, value: 5}]
    }
  },
  created() {
    console.log("create video")
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserVideoList') || "[]")
    this.fetchVideoList()
    // this.fettchSampleList()
    this.debouncedFetchData = this.debounce((data) => this.checkZan(data), 300)
    this.debouncedOutData = this.debounce((data) => this.outZan(data), 300)
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null
    }
  },
  methods: {
    use_only(data){
      if(data.data.img_url){
        this.create_form.create_type = 2;
      }else{
        this.create_form.create_type = 1;
      }
      if(data.type == 0){
        this.create_form.img_url = data.data.img_url;
      }
      if(data.type == "desc"){
        this.create_form.desc = data.data.desc;
      }
      this.setScore();
    },
        // 创建同款
    createSame(data){
      if(data.img_url){
        this.create_form.create_type = 2;
      }else{
        this.create_form.create_type = 1;
      }
      this.create_form.desc = data.desc;
      this.create_form.img_url = data.img_url;
      this.create_form.id = data.id
      this.create_form.md5_key = utils.setMd5Key(data.id)
      this.setScore();
    },
    cdn_url_replace(url, o_url, c_url){
      if (!c_url){
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url){
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://faceswap8.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, {
          cdnDomain: 'cdnfaceswap8.m.nengshuohuihua.com'
        })
      }
      return url.replace(o_url, c_url)
    },
    testScroll() {
      // console.log('滚动');
      utils.setScrollDoc()

    },
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    tozanFn(data, ind) {
      console.log(data)
      this.$http.get(`/front/aivideo/votes/${data.id}/`, {
        params: {
          soft: '2'
        }
      }).then(res => {
        data.votes++
        data.is_vote = 1
        const clickedItem = this.sampleSysList[ind];
        this.sampleSysList.splice(ind, 1); // 删除原位置的元素
        this.sampleSysList.unshift(clickedItem); // 插入到数组开头
      }).catch((err) => {
        console.log('走错误');
        if (!this.isLogin) {
          this.imgDialogVisible = false
          this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setShowLogin', true)
          }).catch(() => {
          });
          return false;
        } else {

        }
      })
    },

    checkZan(data) {
      if (!this.isLogin) {
        this.zanID = data.id
      } else {
        if (data.id == this.zanID) return
        this.$http.get(`/front/aivideo/votes/${data.id}/`, {
          params: {
            soft: '1'
          }
        }).then(res => {
          console.log('zanqingkuang ')
          console.log(res)
          this.zanID = data.id
          if (res.data.is_vote) {
            this.isZan = true
          }

          this.votes = res.data.votes
        })
      }
    },
    outZan(data) {
      console.log('执行离开')
      this.zanID = 0
      this.isZan = false
    },
    changeTab(data) {
      this.create_form.create_type = data
      this.create_form.is_hd = 0
      this.setScore()
      this.setScore()
    },
    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    fettchSampleList() {
      this.SampleListDisabled = true
      // 获取样例数据
      this.$http.get('/front/aivideo/sample/', {
        params: {
          page: this.page,
          size: 5,
          soft: 4,
        }
      }).then((res) => {
        console.log('样例', res)
        this.page++
        this.SampleListDisabled = false
        if (res.data.item_list.length < 5) {
          this.SampleListDisabled = true
          this.$message.warning('样例已全部加载')
        }
        this.sampleSysList = this.sampleSysList.concat(res.data.item_list)

      })
    },
    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      if (!this.checkLogin()) {
        return
      }
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning'
      }).then(() => {
        this.sampleSysList.splice(index, 1)
        let j = -1
        for (let i = 0; i < this.sampleUserList.length; i++) {
          if (this.sampleUserList[i].id == item.id) {
            j = i
          }
        }
        if (j > -1) {
          this.sampleUserList.splice(j, 1)
          localStorage.setItem("sampleUserVideoList", JSON.stringify(this.sampleUserList))
        }
      })
    },
    choose_tips_item(item) {
      // 样例 选中
      if (!this.checkLogin()) {
        return
      }
      let _item = {...item}
      _item.progress = 0
      this.sampleSysList.unshift(_item)

      this.sampleUserList.unshift(item)
      localStorage.setItem("sampleUserVideoList", JSON.stringify(this.sampleUserList))
      if (this.sampleTimer != null) {
        // this.scrollToTop()
        return
      }
      this.sampleTimer = setInterval(() => {
        let createNum = 0; // 需要生成个数
        this.sampleSysList.forEach(e => {
          if (e.progress < 100) {
            createNum += 1
            let num = parseInt(Math.random() * 10);
            if (e.progress + num > 100) {
              e.progress = 100
              // this.scrollToTop()
            } else {
              e.progress += num
            }
          }
        })
        if (createNum == 0) {
          clearInterval(this.sampleTimer)
          this.sampleTimer = null
          // this.scrollToTop()
        }
      }, 500)
    },
    fetchVideoList() {
      this.$http.get(`/front/aivideo/user/video/?soft=4`, {params: {max_mj_id: this.max_mj_id}}).then(res => {
        if (res.status == '200') {
          this.noMore = false
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {
                if (e.status <= 1 || (e.status == 2 && e.video_url == "")) {
                  this.checkIds.push(e.id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].id
            this.video_list = this.video_list.concat(res.data.item_list)
            this.video_list.forEach(item => {
              if (item.regenLoading != 1) {
                item.regenLoading = 0
              }
            })
          } else {
            this.noMore = true
            if (this.max_mj_id == 0) {
              this.fettchSampleList()
            }
          }
        } else {
          this.fettchSampleList()
        }
      }).finally(() => {
      })
    },
    fetchMsg() {
      if (this.checkIds.length === 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null
      }
      this.timer = setInterval(() => {
        this.$http.post('/front/aivideo/check/', {ids: this.checkIds}).then((res) => {
          if (res.status === "200") {
            let item_list = res.data.item_list;
            let _id = 0;

            item_list.forEach(e => {
              _id = e.id
              if (e.status == 3 && e.error_message == '服务异常,请联系客服') {
                this.$confirm("服务异常,请联系客服", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                }).catch(() => {

                });
                this.checkIds = this.checkIds.filter(i => i !== _id)
                this.video_list.forEach((item, index,) => {
                  if (item.id == _id) {
                    item.status = 3
                  }
                })

              } else if (e.status == 3 && e.error_message == '任务提交失败，请重试！') {
                this.$confirm("生成异常，已为您重新排队", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                }).catch(() => {

                });
                this.create_form.desc = e.text_prompt_cn
                this.create_form.img_url = e.img_url
                this.create_form.mode = e.mode
                this.create_form.seconds = e.seconds
                this.create_form.style = e.style
                this.create_form.duration = e.seconds
                // this.create_form.exploreMode = e.exploreMode== 1? true:false

                this.checkIds = this.checkIds.filter(i => i !== _id)
                this.video_list.forEach((item, index,) => {
                  if (item.id == _id) {
                    item.status = 3
                  }
                })
                this.clickSubmit()
              } else if (e.status == 3 && e.show_error_message) {
                this.$message.error(e.error_message)
              }
              let item = this.video_list.filter((obj) => obj.id === _id)[0];
              item.status = e.status
              item.is_public = 0
              item.img_url = e.img_url
              let num = parseInt(Math.random() * 10);
              if (item.progress + num > 100) {
                item.progress = 99
              } else {
                item.progress += num
              }
              if (e.status > 2) {
                // 删除生成成功或失败的
                this.checkIds = this.checkIds.filter(i => i !== _id)
              }
              if (e.status == 2 && e.local_video_url != null) {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== _id)
                // 生成成功 并下载本地
                console.log("生成成功 并下载本地", e)
                // item.video_url =e.local_video_url==null ||e.local_video_url==''?e.video_url:e.local_video_url
                item.local_video_url = e.local_video_url
                item.cover_url = e.cover_url
                item.img_url = e.img_url
                item.text_prompt = e.text_prompt
                item.regenLoading = 0
                item.progress = 100
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status === 3) {
                // 失败
                item.show_error = e.show_error
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.video_list.forEach((_list, num) => {
                  if (_list.id == e.id) {
                    this.video_list[num] = e
                  }
                })
              }
            })
          }
          if (this.checkIds.length === 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          console.log(res)
          clearInterval(this.timer);
        })
      }, 5000)
    },
    showTishici(){
      if(this.$refs.lingganref){
        this.$refs.lingganref.visible = false
        this.$refs.lingganref.show_detail_popup = false
      }
      if(document.querySelector('.autoMatic_box')){
        this.$refs.promptBox.show(false)
      }else{
        if (!this.isLogin) {
          this.$message.warning('请先登录！')
          return
        }
        if(!this.create_form.desc.trim().length){
          this.$message.warning('请输入创意描述！')
          return 
        }
        this.$refs.promptBox.show(true)
      }
    },
    clickSubmit() {
      if (!this.checkLogin()) {
        return
      }
      if(SITE_BTN_CONFIG.btn_luma_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      // if (this.userInfo.is_vip == 0 || this.userInfo.is_vip_end == 1) {
      //   this.$store.commit('setToastVip', true);
      // }
      this.create_form.name = this.create_form.desc
      this.create_form.text_prompt = this.create_form.desc
      if (this.create_form.create_type === 2 && this.create_form.mode == 'Sora') {

      } else {
        if (this.create_form.text_prompt === "") {
          this.$message.warning('请输入描述')
          return
        }
      }
      if (this.create_form.text_prompt.length > 500) {
        this.$message.warning('描述信息不能超过500字符')
        return
      }


      if (this.create_form.create_type === 1) {
        this.create_form.img_url = ""
      }
      if (this.sendLoading) {
        this.$message.warning('正在提交任务！')
        return
      }
      if (this.create_form.create_type === 2) {
        if (this.create_form.img_url == '') {
          this.$message.warning('请上传图片')
          return;
        }
        if (this.create_form.mode == 'Runway3' && this.frame == true) {
          //this.create_form.img_urls = this.select_rec_img.img_url
          this.create_form.img_url = ''
        } else {
          //this.create_form.img_url = this.select_rec_img.img_url
          this.create_form.img_urls = ''
        }
      }
      if (!this.create_form.is_hd && !this.isTips) {
        this.$confirm('标清生成质量稍差，90%用户选择高清生成，是否切换为高清生成？', '提示', {
          confirmButtonText: '高清生成',
          cancelButtonText: '标清生成',
          type: 'warning'
        }).then(() => {
          this.create_form.is_hd = 1
          this.clickSubmit()
        }).catch(() => {
          this.create_form.is_hd = 0
          this.isTips = true
          this.clickSubmit()
        })
        return false
      }
      // if (this.auto_spell > 0) {
      //   console.log('ai提示词')
      //   if (!this.perIncan) {
      //     this.$refs.promptBox.show(true)
      //     return;
      //   }
      // }
      this.create_form.seconds = this.create_form.duration
      console.log(this.create_form)

// return;
      this.create_form.is_optimize = this.create_form.auto_optimize
      this.sendLoading = true
      this.getPromptData3()
      if(this.create_form.md5_key){
        this.$http.get(`https://payadmin.m.nengshuohuihua.com/wap/siteconfig/useexample/`,{
          params:{
            id:this.create_form.id,
            md5_key:this.create_form.md5_key
          }
        }).then(res=>{
          this.create_fun(this.create_form)
        })
      }else{
        this.create_fun(this.create_form)
      }
    },
    create_fun(data){
      this.$http.post('/front/aivideo/', data).then(res => {

        if (res.status === '200') {
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          this.getProfile()
          this.create_form.desc = "";
          let video = res.data.video
          video.progress = 0
          this.create_form.is_hd = 0
          this.isTips = false
          this.video_list.unshift(video);
          //this.scrollToTop();
          this.checkIds.push(video.id)
          this.fetchMsg()
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(res => {
        console.log(res)
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {
        this.sendLoading = false
      })
    },
    loadMore() {
      console.log("加载更多")
      // this.page++;
      this.noMore = true
      this.fetchVideoList()
    },
    deleteVideo(index, msg) {
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aivideo/${msg.id}/`).then(res => {
          if (res.status == '200') {
            this.$message.success('删除成功')
            this.video_list.splice(index, 1)
            if (this.video_list == []) {
              this.max_mj_id = 0
              this.page = 0
              this.fetchVideoList()
            }
          }
        })
      }).catch(() => {
      });
    },

    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.imgDialogVisible = false
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },
    handleAvatarSuccess(res, file) {
      this.upImgloading = false
      if (res.data.error !== '') {
        this.$message.error(res.data.error)
        return
      }
      this.create_form.img_url = res.data.file_full_url
    },
    beforeAvatarUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      let isSole = true
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!');
        return
      }
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          let wS = img.width / img.height
          let hS = img.height / img.width
          if ((wS >= 0.4 && wS <= 2.5) || (hS >= 0.4 && hS <= 2.5)) {
            if (img.width <= 500 || img.height <= 500) {
              reject({isSole: false})
              // this.$message.error('图片大小需要大于500小于4090');
              this.$message({
                message: '图片大小需要大于500小于4090',
                type: 'warning'
              })
              return false
            }
            if (img.width >= 4090 || img.height >= 4090) {
              reject({isSole: false})
              // this.$message.error('图片大小需要大于500小于4090');
              this.$message({
                message: '图片大小需要大于500小于4090',
                type: 'warning'
              })
              return false
            }
          } else {
            reject({isSole: false})
            // this.$message.error('图片大小需要大于500小于4090');
            this.$message({
              message: '图片宽高比需在5:2或2:5之内',
              type: 'warning'
            })
            return false
          }
          this.upImgloading = true
          resolve({isSole});
        }
      })

    },
    recommend(video_id, index) {
      console.log(video_id)
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      let data
      //   sys_cae_id:1

      this.$http.patch('/front/aivideo/user/video/' + video_id + '/', {
        action: "public",
        data: {sys_cate_id: 1}
      }).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '推荐成功，请等待审核！',
            type: 'success'
          });
          this.video_list[index].is_public = 1

        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        console.log(res)
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {

      })
    },
    sample_btn(name) {
      if (!this.checkLogin()) {
        return
      }

      if (name == 'del') {
        this.$message({
          message: '样例数据不能删除！请创作后重试。',
          type: 'warning'
        });
      }else if (name == 'noDown') {
        this.$message({
          message: '样例数据不能下载！请创作后重试。',
          type: 'warning'
        });
      } else {
        this.$message({
          message: '样例数据不能推荐到广场！请创作后重试。',
          type: 'warning'
        });
      }
    },
    // 视频播放暂停 仅一个视频播放
    handlePlay(type,currentIndex,item) {
      this.$nextTick(() => {
        if(type == 'play'){
          if(item.dainjizanting){
            return
          }
          this.sampleSysList.forEach((video, index) => {
            if (index == currentIndex) {
              video.dainjizanting = true
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayer${index}`][0]
              if(videoElement.paused){
                videoElement.play()
              }else{
                videoElement.pause()
              }
            }
          });
        }else{
          this.sampleSysList.forEach((video, index) => {
            if (index !== currentIndex) {
              // 暂停其他视频
              if (video.status == 2) {
                // 暂停其他视频
                const videoElement = this.$refs[`videoPlayer${index}`][0];
                videoElement.pause();
              }
            }
          });
        }

      });
    },
    onVideoPlay(type,currentIndex,item) {
      if(type == 'play'){
        if(item.dainjizanting){
          return
        }
        this.video_list.forEach((video, index) => {
          if (index == currentIndex) {
            video.dainjizanting = true
            // 暂停其他视频
            const videoElement = this.$refs[`videoPlayers${index}`][0]
            if(videoElement.paused){
              videoElement.play()
            }else{
              videoElement.pause()
            }
          }
        });
      }else{
        this.video_list.forEach((video, index) => {
          if (index !== currentIndex) {
            // 暂停其他视频
            if (video.status == 2) {
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayers${index}`][0];
              videoElement.pause();
            }
          }
        });
      }

    },
    selectDefinition(model, index) {
      this.create_form.is_hd = model.value
      this.setScore()
    },
    selectDuration(model, index) {
      this.create_form.duration = model.value
      this.setScore()
    },
    setScore() {
      console.log()
      if (this.create_form.create_type == 1) {
        console.log('文生视频')
        if (this.create_form.is_hd == 0) {
          this.scoreCode = 25
        } else if (this.create_form.is_hd == 1) {
          this.scoreCode = 50
        }
      } else {
        console.log('图省事视频')
        if (this.create_form.is_hd == 0) {
          this.scoreCode = 25
        } else if (this.create_form.is_hd == 1) {
          this.scoreCode = 50
        }

      }

    },
    regenerate(item, index) {
      console.log(item)
      console.log('重新生成')
      this.video_list[index].regenLoading = 1
      this.$forceUpdate()
      this.$http.post(`/front/aivideo/retry/`, {id: item.id}).then(res => {
        console.log('res', res)
        if (res.status == '200') {
          this.$message.success('重新生成创建成功')
          this.scrollToTop()
          this.video_list[index].is_retry = 1
          this.video_list.unshift(res.data.video);
          this.checkIds.push(res.data.video.id)
          this.fetchMsg();
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err => {
        console.log('err', err)
        this.video_list[index].regenLoading = 0
      }).finally(() => {
        this.video_list[index].regenLoading = 0
        this.$forceUpdate()
      })
    },
    showDefeatPopup() {
      this.$refs.retryPop.show();
    },
    getPromptData2(data) {
      this.create_form.desc = data
      // this.perIncan = true
      // this.clickSubmit()
    },
    getPromptData3() {
      // ai提示词重置
      this.perIncan = false
      this.$refs.promptBox.show(false)
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的视频内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
    downloadVideo(is_video,index ) {
      if (!this.checkLogin()) {
        return
      }
      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        }else{
          let message = res.message;
          utils.createErrTip(message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#video_page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #fff;
  background-color: rgb(49, 51, 56);
  display: flex;
  font-size: 14px;

  .left_part {
    width: 350px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-color: rgb(43, 45, 49);

    .left_main {
      padding: 10px;
      overflow: hidden;
      flex: 1 1 0%;
      display: flex;
      flex-direction: column;

      .left_tabs {
        display: flex;
        border: 1px solid rgb(54, 55, 61);
        background-color: rgb(49, 51, 56);
        margin-bottom: 10px;
        padding: 4px;
        height: 40px;
        gap: 4px;
        border-radius: 6px;

        .tab_item {
          font-size: 13px;
          border-radius: 4px;
          cursor: pointer;
          flex: 1 1 0%;

          &.active {
            background-color: #5865F2;
          }
        }
      }

      .tools_introduce {
        border-radius: 6px;
        background-color: rgb(30, 31, 34);
        padding: 16px 14px;
        display: flex;

        .face_icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: none;
        }

        .introduce_main {
          flex-grow: 1;

          .introduce_title {
            font-size: 14px;
            line-height: 19px;
            font-weight: 700;
          }

          .introduce_text {
            font-size: 12px;
            line-height: 19px;
            margin-top: 5px;
          }
        }
      }

      .form_wrap {
        flex: 1 1 0%;
        overflow-y: auto;

        .form_title {
          margin: 12px 0;
          display: flex;

          .title_icon {
            border-radius: 3px;
            //height: 15px;
            width: 4px;
            background-color: #5865F2;
          }

          .title_text {
            flex-grow: 1;
            margin-left: 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .tishici{
              cursor: no-drop;
              border-radius: 4px;
              padding: 0 6px;
              background: #1d2027;
            }
            .tishici_act{
              cursor: pointer;
              background: #5865f2;
            }
          }
        }

        .upload_wrap {
          height: 140px;
          font-size: 20px;
          border: 1px dashed #42464e;
          position: relative;
          border-radius: 6px;

          &:hover {
            border-color: #5865f2;
          }

          :deep(.el-upload-dragger) {
            width: 100%;
            height: 100%;
            background: #1d2027;
            padding: 0;
            border-radius: 6px;
            border: none;
          }


          .upload_inner {
            width: 100%;
            height: 100%;
            flex-direction: column;

            .el-icon-plus {
              margin-bottom: 8px;
              font-size: 30px;
              font-weight: bold;
              color: rgb(192, 196, 204);
            }

            .upload_text {
              font-size: 14px;
              text-align: center;
              color: #606266;
              line-height: 20px;
            }

            .upload_img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
              border: none;
            }

            .el-icon-delete {
              position: absolute;
              cursor: pointer;
              color: #fff;
              right: 12px;
              bottom: 12px;
              font-size: 16px;
            }
          }
        }

        .desc_box {
          position: relative;
          border-radius: 6px;
          height: 130px;
          padding: 10px;
          background-color: rgb(46, 48, 61);
          border: 2px solid #5865F2;

          :deep(.el-textarea__inner) {
            font-size: 13px;
            padding: 0;
            background: transparent;
            border: none;
            box-shadow: none;
            resize: none;
            color: rgba(255, 255, 255, .78);
          }

          .desc_box_bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            align-items: center;
            font-size: 14px;

            .bottom_left {
              // height: 20px;
              display: flex;
              align-items: center;
              cursor: pointer;
              background: linear-gradient(to right, #fd7a57, #fe3f40);
              border-radius: 4px;
              padding: 3px 2px 5px 20px;
              font-size: 12px;
              user-select: none;
              color: #fff;
              position: relative;
              opacity: 0.5;
              .ai_tishi_img{
                width: 12px;
                height: 12px;
                position: absolute;
                left: 5px;
                top: 50%;
                transform: translateY(-50%);
                // margin-right: 4px;
              }
            }

            .cleat_desc_btn {
              cursor: pointer;
              color: #b4b9bf;

              &:hover {
                color: #fff;
              }
            }
          }
        }

        .select_item {
          font-size: 13px;
          background-color: #1d2027;
          border-radius: 4px;
          border: 2px solid #1d2027;
          cursor: pointer;

          &.active {
            border-color: #5865f2;
            background-color: rgba(88, 101, 242, 0.15);
          }
        }

        .model_wrap {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 5px;

          .model_item {
            position: relative;
            width: 88px;
            height: 40px;

            .need_vip {
              position: absolute;
              color: #f0b132;
              line-height: 17px;
              font-weight: 700;
              top: -10px;
              right: 0;
            }
          }
        }

        .model_desc {
          color: #a6a6a6;
          margin-top: 8px;
          font-size: 12px;
          word-break: break-all;
          white-space: normal;
        }

        .style_wrap {
          display: flex;
          align-items: center;

          .style_item {
            margin-right: 10px;
            width: 64px;
            height: 40px;
          }
        }

        .size_wrap {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;

          .size_item {
            width: 64px;
            height: 80px;
            flex-direction: column;

            .size_img {
              width: 36px;
              height: 40px;
              display: block;
              border: none;
            }

            .size_type {
              font-size: 13px;
              margin-top: 6px;
              color: #8e9093;
            }
          }
        }

        .Reference_image {
          width: 100%;
          height: 140px;
          overflow: hidden;

          .upload-demo {
            height: 100%;
            width: 100%;
          }

          /deep/ .el-upload-dragger {
            width: 324px;
            background-color: #1d2027;
            border-color: #3e4149;
            height: 140px;
          }

          /deep/ .el-upload-dragger:hover {
            border-color: #5865f2;
            height: 140px;
          }

          .noUpload {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #606266;
          }

          .yesUpload {
            position: relative;

            .yesUpload_img {
              height: 140px;
            }

            .yesUpload_icon {
              position: absolute;
              right: 8px;
              bottom: 12px;
              //background-color: aquamarine;
              color: #c1bfbb;
              font-size: 25px;
            }


          }
        }
      }
    }

    .left_footer {
      height: 80px;
      border-top: 1px solid #42464e;
      padding: 0 30px;
      display: flex;
      align-items: center;

      .primary_button {
        font-size: 16px;
        height: 46px;
        border-radius: 23px;
        width: 100%;

        /deep/ .el-loading-mask {
          background: none;
        }

        &.disabled_btn {
          cursor: not-allowed;
          background-color: #393b3f;
          user-select: none;
          color: #999;
        }
      }
    }

    .newSubList {
      width: 330px;
      //height: 90px;
      margin: 0 auto;
      padding: 15px 0 0;
      display: flex;
      border-top: 1px solid #42464e;
      flex-direction: column;

      .newSumitList{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .newSumit {
        flex-shrink: 0;
        width: 122px;
        height: 55px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #5865f2;
        // text-align: center;
        border-radius: 10px;
        // padding: 0 10px;
        cursor: pointer;
        font-size: 14px;
        // line-height: 19px;
        .subText {
          font-size: 10px;
        }
      }

      .newSumitOther {
        // margin-left: 20px;
        width: 198px;
        position: relative;
        background: linear-gradient(to right, #fd7a57, #fe3f40);

        .subImg {
          position: absolute;
          right: 52px;
          top: 0px;
        }
      }

      .newSumitOthers {
        width: 90%;
        margin: 0 auto;
        background: #393b3f;
        color: #999;
        cursor: no-drop;
      }

      .screen{
        color:#666;
        text-align: center;
        margin: 10px 0;
        font-size: 12px;
      }
    }
  }

  .main_part {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;

    .top_tips {
      height: 48px;
      padding: 0 16px;
      border-bottom: 1px solid #26282c;
      display: flex;
      align-items: center;

      .one {
        font-size: 18px;
        color: #949ba4;
      }

      .two {
        font-size: 16px;
        color: #fff;
        margin: 0 10px;
        white-space: nowrap;
      }

      .three {
        font-size: 12px;
        color: #f0b132;
      }
    }

    .create_center {
      flex: 1 1 0%;
      padding-right: 5px;
      overflow-y: auto;

      .message_list {
        // height: 100%;
        // overflow: hidden;
        // overflow-x: hidden;
        padding-bottom: 10px;
        // overflow-y: auto;

        .list_item {
          margin: 10px 10px 10px 0;
          background-color: #403d38;
          border-left: 2px solid #f0b132;
          padding: 20px;
          overflow: hidden;
          word-break: break-all;
          white-space: normal;
          line-height: 20px;

          .item {
            display: flex;

            .item_touxiang {
              width: 50px;
              margin-right: 10px;
            }
          }

          .item_right {
            flex: 1 0;
          }

          .item_top {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 10px;

            .top_left {
              display: flex;
              align-items: center;

              .item_type {
                //height: 24px;
                padding: 2px 12px;
                margin: 0 8px;
                background-color: #4b5196;
                border-radius: 4px;
                white-space: nowrap;
              }

              .item_time {
                white-space: pre-wrap;
                color: #707070;
              }
            }

            .top_right {
              display: flex;
              align-items: center;
              white-space: nowrap;
              margin-left: 8px;
              color: #949ba4;
              cursor: pointer;

              div:hover {
                color: #fff;
              }

              .el-icon-delete {
                font-size: 14px;
                margin-right: 3px;
              }
            }
          }

          .msg_text {
            word-break: break-all;
            white-space: normal;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .split_line {
            margin: 10px 0;
            height: 1px;
            background-color: #555041;
          }

          .msg_desc {
            color: #99916b;
          }

          .video_wrap {
            margin-top: 10px;
            min-width: 800px;
            position: relative;

            .tozan {
              -webkit-user-select: none;
              /* Safari */
              -moz-user-select: none;
              /* Firefox */
              -ms-user-select: none;
              /* IE10+/Edge */
              user-select: none;
              display: flex;
              flex-direction: column;
              align-items: end;
              position: absolute;
              right: 20px;
              top: 10px;

              .zanOne {
                width: 90px;
                height: 30px;
                display: inline-flex;
                line-height: 30px;
                background-color: #ffffff; /* 背景颜色 */
                color: #000; /* 文字颜色 */
                border: none;
                border-radius: 3px; /* 圆角 */
                font-size: 14px;
                cursor: pointer;
                box-shadow: 0 0 8px rgba(255, 255, 255, .1), 0 0 10px rgba(255, 255, 255, .2), 0 0 10px rgba(255, 255, 255, .5); /* 荧光效果 */
                .zanImg {
                  width: 18px;
                  height: 18px;
                  margin: 0 10px;
                  font-size: 0;
                  margin-top: 5px;
                }
              }

              .zanTex {
                font-size: 14px;
                color: #99916b;
                margin: 15px 0;
              }

              .zanTwo {
                color: #f0b53e; /* 文字颜色 */
                box-shadow: 0 0 8px rgba(241, 170, 38, 0.1), 0 0 10px rgba(248, 163, 53, 0.2), 0 0 10px rgba(255, 255, 255, .5); /* 荧光效果 */
                cursor: auto;
              }
            }

            .creating {
              position: relative;

              .loading_text {
                padding-left: 12px;
                color: #f0b132;
              }

              .progress {
                font-weight: 700;
                font-size: 13px;
                margin: 20px 0 0 10px;
                color: #f0b132;
                z-index: 1;
              }

              .loading_gif {
                width: 100px;
                margin: 20px;
                display: block;
                border: none;
              }
            }

            //失败
            .error_video {
              width: 190px;
              //height: 190px;
              background-color: #fff;
              border-radius: 4px;
              padding: 14px 10px;
              text-align: center;
              font-size: 14px;
              margin-top: 20px;

              .error_icon {
                display: block;
                width: 35px;
                margin: 0 auto;
              }

              .error_text {
                color: #ccc;
                //line-height: 64px;
                margin: 10px 0 36px;
              }

              .error_text2, .error_text3 {
                font-size: 12px;
                color: #56b15b;
              }

              .error_text2 {
                cursor: pointer;
                margin-bottom: 5px;
              }

              .error_text3 {
                color: #ccc;
                margin-bottom: 36px;
              }

              .error_text4 {
                font-size: 12px;
                color: #ccc;
                line-height: 1.8;

                a {
                  color: red;
                }
              }

              .error_btn {
                display: inline-block;
                cursor: pointer;
                color: #ffab46;
                padding-top: 15px;
              }
            }


            .success_shou {
              display: flex;

              .icon_you {
                width: 50px;
              }

              .success_shouVideo {
                position: relative;
                width: 700px;
                height: 400px;
                background-color: #080707;

                video {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%; /* 设置视频宽度为父容器的100% */
                  height: 100%; /* 保持视频的宽高比 */
                }

                .success_img {
                  position: absolute;
                  display: inline-block;
                  top: 5px;
                  right: 5px;
                  border: 1px solid #FFF;

                  img {
                    display: block;
                    width: 100px; /* 根据需要调整图片宽度 */
                    height: auto;
                    cursor: pointer;
                  }

                  img:hover .success_imgdel {
                    position: absolute;
                    top: 0; /* 调整图标距离顶部的距离 */
                    right: 0; /* 调整图标距离右侧的距离 */
                    border-radius: 50%; /* 使图标背景为圆形 */
                    font-size: 18px; /* 根据需要调整图标字体大小 */
                    color: #333; /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;
                  }

                  .success_imgdel {
                    position: absolute;
                    top: 0; /* 调整图标距离顶部的距离 */
                    right: 0; /* 调整图标距离右侧的距离 */
                    border-radius: 50%; /* 使图标背景为圆形 */
                    font-size: 18px; /* 根据需要调整图标字体大小 */
                    color: #333; /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;

                    span {
                      font-size: 12px;
                    }

                    i {
                      font-size: 12px;
                      background-color: #fff;
                      border-radius: 50%;
                    }
                  }

                  .success_imgdel:hover {
                    color: white;

                    i {
                      font-size: 12px;
                      background-color: #2b2d31;
                      border-radius: 50%;
                    }
                  }

                }
              }

              .success_img:hover {
                .success_imgdel {
                  display: flex;
                }
              }
            }
          }
        }
      }
    }
  }

  .img-uploader {
    width: 100%;
    height: 100%;

    :deep(.el-upload) {
      width: 100%;
      height: 100%;
    }
  }
}

.desc_popover {
  color: #b5bac1;

  .desc_popover_top {
    padding: 4px 4px 10px;
  }

  .recommend_list {
    height: 300px;
    overflow-y: auto;

    li {
      border-radius: 3px;
      padding: 10px 8px;
      cursor: pointer;
      display: flex;

      &:hover {
        background-color: rgb(43, 45, 49);
      }

      .rec_img {
        height: 34px;
        width: 48px;
        margin-right: 8px;
        display: block;
        border: none;
      }

      .rec_text {
        flex: 1 1 0%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        overflow: hidden;

        .rec_title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .rec_desc {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.recommend_dialog {
  width: 470px;
  color: #fff;

  .el-icon-error {
    position: absolute;
    color: #707072;
    font-size: 16px;
    top: 10px;
    right: 15px;
    cursor: pointer;
    padding: 6px;
  }

  .dialog_title {
    font-size: 16px;
    height: 54px;
    padding: 0 20px;
    background-color: #2B2D31;
    display: flex;
    align-items: center;
  }

  .dialog_body {
    font-size: 13px;
    padding: 20px;

    .body_title {
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      .title_icon {
        border-radius: 3px;
        height: 15px;
        width: 4px;
        background-color: #5865F2;
      }

      .title_text {
        flex-grow: 1;
        margin-left: 6px;
      }
    }

    .img_wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .img_item {
        border-radius: 6px;
        width: 100px;
        height: 82px;
        border: 2px solid #282d31;
        overflow: hidden;
        cursor: pointer;
        position: relative;

        &.active {
          border-color: #5865f2;
        }

        .rec_img {
          display: block;
          border: none;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .img_name {
          position: absolute;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.56);
          height: 23px;
          font-size: 12px;
          left: 0;
          bottom: 0;
        }
      }
    }

    .upload_tips {
      margin: 10px 0;
      color: #6e6e6e;
      user-select: none;
      display: flex;
      align-items: center;

      .vip_tag {
        font-weight: 700;
        color: #f0b132;
      }
    }

    .upload_wrap {
      height: 100px;
      color: #8e9093;
      background-color: #1d2027;
      border: 1px dashed #42464e;
      cursor: pointer;

      .result_wrap {
        width: 100%;
        height: 100%;

        .upload-demo {
          height: 100%;
          width: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 100px;
        }
      }

      .show_img {
        position: relative;
        width: 100%;
        height: 100%;

        .select_img {
          height: 100%;
          display: block;
          border: none;
        }

        .el-icon-delete {
          position: absolute;
          right: 10px;
          bottom: 10px;
          cursor: pointer;
          font-size: 16px;
        }
      }

      .no_img {
        width: 100%;
        flex-direction: column;
        height: 100%;
        color: #8e9093;

        .upload_icon {
          font-weight: 700;
          font-size: 30px;
        }
      }
    }

    .dialog_footer {
      margin-top: 10px;
      gap: 10px;

      .footer_btn {
        border-radius: 4px;
        height: 38px;
        width: 180px;
      }
    }
  }
}

.el-message-box__btns button span {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 70px;
  height: 50px;
  border-radius: 50%;
  margin-right: 7px;
  cursor: pointer;
}


</style>